// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-menu
    v-model="menu"
    transition="scale-transition"
    offset-y
    :disabled="disabled"
    full-width
    max-width="290px"
    min-width="290px"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{on}">
      <v-text-field
        v-on="on"
        slot="activator"
        :label="label"
        v-model="date"
        readonly
        :disabled="disabled"
        hide-details
      ></v-text-field>
    </template>
    <v-date-picker v-model="date" no-title scrollable :allowedDates="allowedDates">
    </v-date-picker>
  </v-menu>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    // allowedDates see vuetify documentation
    allowedDates: null,
    // disable inputs to this selector
    disabled: Boolean,
    // label - text input label
    label: String,
    // v-model input
    value: null
  },

  data () {
    return {
      date: this.formatDate(this.value),
      menu: null
    }
  },

  watch: {
    date () {
      this.$emit('input', this.parseDate(this.date))
    },

    value (val) {
      this.menu = false
      this.date = this.formatDate(this.value)
    }
  },

  methods: {
    parseDate: function (date) {
      if (!date) {
        return date
      }
      return moment(date).format()
    },

    formatDate: function (date) {
      if (date) {
        if (moment(date).isBefore('1000-01-01') || date === null) {
          return moment().format('YYYY-MM-DD')
        }
        return moment(date).format('YYYY-MM-DD')
      }
      return date
    }
  }
}
</script>



// WEBPACK FOOTER //
// DateView.vue?302fb2ca